import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItemText,
  ListItem,
} from '@mui/material';

const UnlinkPointsDialog = ({
  open,
  column,
  editing,
  setCurrentlyEditing,
  setCurrentEditor,
  actions,
}) => {
  if (!editing || editing.length <= 0) return null;
  const affectedPoints = editing.filter((point) => point.equip);
  const promotedPoints = affectedPoints.filter((point) => point.promoted_point_id);
  const action = actions.find((a) => a.id === column.action);
  const affectedEquipment = Array.from(
    Map.groupBy(
      affectedPoints.flatMap((p) => p.equip),
      (equip) => equip.equip_id
    )
      .values()
      .map((list) => list[0])
  );

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Unpublish</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" component="label" htmlFor="myField">
          {promotedPoints.length > 0 &&
            `${promotedPoints.length} published point${
              promotedPoints.length > 1 ? 's' : ''
            } will be unpublished and `}
          {affectedPoints.length} total point{affectedPoints.length > 1 && 's'} will be unlinked
          from the following equipment:
          <List sx={{ listStyleType: 'disc' }}>
            {affectedEquipment.map((equip) => (
              <ListItem key={equip.equip_id} sx={{ display: 'list-item', padding: 0 }}>
                <ListItemText primary={equip.name} />
              </ListItem>
            ))}
          </List>
        </Typography>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button
          variant="contained"
          onClick={() => action.doClose({ setCurrentlyEditing, setCurrentEditor })}
          color="error"
          disabled={false}
        >
          Abort
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            action.doSave(affectedPoints);
            action.doClose({ setCurrentlyEditing, setCurrentEditor });
          }}
          color="success"
          disabled={false}
        >
          {promotedPoints.length > 1 ? 'Unpublish' : 'Remove'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnlinkPointsDialog;
